<div id="orManagingCompanyAdministration" class="or-content" [isFeatureAvailable]="'managingCompanyAdmin'" [appIsAuthorizedForManagingCompany]="[ManagingCompanyAuthorityType.MANAGING_COMPANY_ADMIN, ManagingCompanyAuthorityType.MANAGE_GLOBAL_AUTHORITY_REQUEST]">
  <div class="or-content-header">
    <ul class="or-inline-items or-pull-left">
      <li class="or-inline-item">
        <app-tabs [tabs$]="tabs$"></app-tabs>
      </li>
    </ul>

    <ul class="or-inline-items or-pull-right">
      <li class="or-inline-item mc-switcher">
        <mat-form-field class="w-full sm:w-96 md:w-[300px] sm:ml-2">
          <mat-label data-cy='change-managing-company-label'>Change Managing Company</mat-label>
          <mat-select
            [value]="selectedManagingCompanyId"
            (selectionChange)="onManagingCompanyChanged($event.value)"
          >
            @for (managingCompanies of (adminManagingCompanies$ | async) ?? []; track managingCompanies.id) {
              <mat-option [value]="managingCompanies.id">
                {{ managingCompanies.companyName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </li>
    </ul>
  </div>

  @if (selectedManagingCompanyId !== null) {
    <router-outlet></router-outlet>
  }
</div>